module.exports = __webpack_public_path__ + "static/front/img/equip.7de20d87.svg";